import { Component, OnInit } from '@angular/core';
import { ApiUrlService } from './../../api/services/api-url.service';
// import {} from '@types/googlemaps';
import { environment } from "./../../../environments/environment";
@Component({
    selector: 'app-footer-support',
    templateUrl: './footer-support.component.html',
    styleUrls: ['./footer-support.component.less']
})
export class FooterSupportComponent implements OnInit {
    baseURLForUserGuide: string;
    options: any;
    overlays: any[];

    constructor(private apiURLService: ApiUrlService) {
        this.baseURLForUserGuide = apiURLService.getApiEndpointUrl(
            environment.defaultApiEndpoint
        );
    }

    ngOnInit() {
        this.options = {
            center: {
                lat: 33.964846,
                lng: -117.441677
            },
            zoom: 9
        };
        this.overlays = [
            new google.maps.Marker({ position: { lat: 33.964846, lng: -117.441677 }, title: 'The Toro Company' })
        ];
    }

}
